'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 7.5px;\n'], ['\n  margin-bottom: 7.5px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-right: 5px;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    svg {\n      width: 6px;\n    }\n  }\n'], ['\n  margin-right: 5px;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    svg {\n      width: 6px;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  text-decoration: underline;\n  transition: color ease 0.5s;\n\n  &:hover {\n    text-decoration: underline;\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  text-decoration: underline;\n  transition: color ease 0.5s;\n\n  &:hover {\n    text-decoration: underline;\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

var _TriangleSVG = require('../../../svg/TriangleSVG');

var _TriangleSVG2 = _interopRequireDefault(_TriangleSVG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

Wrapper.displayName = 'Wrapper';

var IconWrapper = _styledComponents2.default.span(_templateObject2);

IconWrapper.displayName = 'IconWrapper';

var ArticleLink = _styledComponents2.default.a(_templateObject3, _config.colors.black, _config.colors.red);

ArticleLink.displayName = 'ArticleLink';

var Link = function Link(_ref) {
  var label = _ref.label,
      url = _ref.url;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      IconWrapper,
      null,
      _react2.default.createElement(_TriangleSVG2.default, {
        height: '10px'
      })
    ),
    _react2.default.createElement(
      ArticleLink,
      {
        href: url
      },
      label
    )
  );
};

Link.propTypes = {
  label: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
};

Link.displayName = 'Link';

exports.default = Link;
Link.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Link',
  'props': {
    'label': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'url': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
};